<template>
  <div class="wrapper-slider">
    <UiResponsiveImage
      :src="image || '/static/images/no-img.svg'"
      draggable="false"
      class="in-image"
      alt=""
      :title="title"
      :mobile-sizes="mobileSizes"
      :desktop-sizes="desktopSizes"
    />
  </div>
</template>
<script lang="ts" setup>
defineProps({
  image: {
    type: String,
    required: true,
  },
  mobileSizes: {
    type: Object as any,
    default: () => ({ width: 296, height: 296 }),
  },
  desktopSizes: {
    type: Object as any,
    default: () => ({ width: 520, height: 520 }),
  },
  title: {
    type: String,
    default: '',
  },
});
</script>

<style scoped lang="scss">
.wrapper-slider {
  display: flex;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  border-radius: 8px;
  background: #f8f8f8;
}
.in-image {
  border-radius: 6px;
  opacity: 0.6;
}
</style>
